var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.45,
    height: 21.32,
    viewBox: "0 0 16.45 21.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-user"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8,17.8C5.2,15.3,2.4,11.4,3.4,6.7a8,8,0,0,1,8-6.2h0a8,8,0,0,1,8,6.2c1.1,4.7-1.8,8.7-4.4,11.1a5.54,5.54,0,0,1-3.6,1.5A6.1,6.1,0,0,1,7.8,17.8ZM4.7,6.9c-.9,4.1,1.6,7.7,4,9.9a3.8,3.8,0,0,0,5.4,0c2.3-2.2,4.9-5.8,4-9.9a6.65,6.65,0,0,0-6.7-5.2A6.65,6.65,0,0,0,4.7,6.9Z",
    transform: "translate(-3.19 -0.5)",
    fill: "{props.color}",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.1,6.9a2.3,2.3,0,1,1,4.6,0,2.3,2.3,0,1,1-4.6,0Zm.6,0a1.7,1.7,0,1,0,3.4,0,1.7,1.7,0,1,0-3.4,0Z",
    transform: "translate(-3.19 -0.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6,13.4c0-1.4-1.4-2.5-3.2-2.5S8.3,12,8.3,13.4a.3.3,0,0,1-.6,0c0-1.7,1.7-3.1,3.8-3.1s3.8,1.4,3.8,3.1a.27.27,0,0,1-.3.3C14.8,13.7,14.6,13.6,14.6,13.4Z",
    transform: "translate(-3.19 -0.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.48,16.2a2.47,2.47,0,0,1,1.38-.43,2,2,0,0,1,.71.1,2.12,2.12,0,0,1,.49.26,1.9,1.9,0,0,1,.43.45,2.18,2.18,0,0,1,.28.78c0,.11,0,.19,0,.3a4.69,4.69,0,0,1,0,.71c0,.32,0,.57,0,.74a7.22,7.22,0,0,1-.12,1.07,1.81,1.81,0,0,1-1,1,6.65,6.65,0,0,1-1,.14c-.38,0-.61,0-1.18,0H7c-.34,0-.68,0-1,0a2.67,2.67,0,0,1-.76,0A1.91,1.91,0,0,1,4.56,21a2,2,0,0,1-.63-.67l-.07-.15a1.85,1.85,0,0,1-.09-.3l0-.26a1.76,1.76,0,0,1,0-.19v-.75c0-.13,0-.39,0-.65a8.19,8.19,0,0,1,0-.84,1.93,1.93,0,0,1,.38-.82A1.88,1.88,0,0,1,5,15.84a2.42,2.42,0,0,1,.74-.07,4.17,4.17,0,0,1,1,.1c-.06-.08-.07-.1-.06-.1s.65.53,1.6,1.28a9.7,9.7,0,0,0,.93.69,6.22,6.22,0,0,0,1.09.59,2.9,2.9,0,0,0,1.68.34,10.4,10.4,0,0,0,1.19-.58,6,6,0,0,0,.94-.55c.22-.18.23-.23.77-.77C15.22,16.43,15.4,16.26,15.48,16.2Z",
    transform: "translate(-3.19 -0.5)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-3.19 -0.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-3.19 -0.5)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationUser);
export default __webpack_public_path__ + "static/media/location-user.dbc0f4c4d45483fa6d0a39b233be5291.svg";
export { ForwardRef as ReactComponent };